export default "<div class=\"under-dev\">\n\n  <img src=\"assets/images/webdevelopment.png\">\n  <p>Under Developing</p>\n\n</div>\n";